import React from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { StyledMember, StyledPanel } from '../stylesheets/styles';
import { API_URL } from '../common/constants';
import classNames from "classnames";
import BgComponent from '../components/BgComponent';

const ResetPassword = () => {
  const { register, handleSubmit, setError, watch, formState: { errors, isSubmitting } } = useForm({
    defaultValues: {
      Password: '',
      ClientUrl: window.location.href.replace('ForgetPwdTest', 'ForgetPwdSend')
    }
  });
  const location = useLocation();
  const watchValue = watch();

  const getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  };

  const onSubmit = async (data) => {
    try {
      const response = await axios.post(`${API_URL}/api/member/resetpwd`, {
        Pwd: data.Password,
        Q: getParameterByName('q')
      }, {
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.data.isSuccess) {
        alert(response.data.message);
      }
    } catch (error) {
      alert(error.response?.data?.message || 'Error submitting reset password');
      console.error('Error submitting reset password:', error);
    }
  };

  console.log('errors', errors);

  return (
    <StyledMember className='register'>
      <div className='member-wrap'>
        <Container>
          <Row className="justify-content-md-center">
            <Col xl="7" lg="10" md="12">
              <StyledPanel>
                <div className="hgroup">
                  <h1 className="text-center">重設密碼</h1>
                </div>
                <Form noValidate onSubmit={handleSubmit(onSubmit)} name="frmResetPwd">
                <div className="form-group mb-3">
                    <label htmlFor="password" className="form-label">密碼*</label>
                    <input 
                      {...register('Password', { 
                        required: true, 
                        minLength: {
                          value: 8,
                          message: '密碼至少8個字元'
                        }
                      })} 
                      type="password"
                      id="Password" 
                      className={`form-control ${errors.Password ? "is-invalid" : ""}`}
                      placeholder="請輸入新密碼"
                    />
                    {errors.Password && <p className="form-helper text-danger">{errors.Password.message}</p>}
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="confirmPassword" className="form-label">再次輸入密碼*</label>
                    <input 
                      {...register("confirmPassword", {
                        required: "確認密碼為必填欄位",
                        validate: (value) =>
                          value === watchValue.Password || "密碼不一致",
                      })}
                      type="password"
                      id="confirmPassword" 
                      className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`}
                      placeholder="再次確認密碼"
                    />
                    {errors.confirmPassword && (
                      <p className="form-helper text-danger">{errors.confirmPassword.message}</p>
                    )}
                  </div>   
                  <div className="form-button pt-4">
                    <Button disabled={isSubmitting} size="lg" variant="dark" className="w-100" type="submit">
                      { isSubmitting ? '處理中...' : '重設密碼' }
                    </Button>
                    {errors.root && <p className={classNames("form-helper mt-2", errors.root.isSuccess ? 'text-success' : 'text-danger')}>{errors.root.message}</p>}
                  </div>
                </Form>
              </StyledPanel>
            </Col>
          </Row>
        </Container>
        <BgComponent/>
      </div>
    </StyledMember>
  );
};

export default ResetPassword;
